import React from "react";

const OutreachIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7888 1.15002C23.9148 1.15002 33.1712 3.03659 37.4801 7.36287C38.5717 8.4598 40 10.6082 40 13.7547C40 19.349 35.5107 27.932 30.5538 32.9103C27.9912 35.4837 23.9148 38.8466 18.4314 38.8466C13.071 38.8466 8.97722 35.191 7.7921 34.0006C3.25205 29.4418 0 22.5222 0 16.0702C0 11.9991 1.15572 8.43842 4.10448 5.47897C6.83546 2.73731 11.5412 1.15002 17.7888 1.15002ZM25.3711 23.4601C27.4394 21.3825 27.9965 18.8239 27.9965 17.4156C27.9965 16.3949 27.7293 14.8971 26.4573 13.6211C24.5066 11.6624 22.3462 11.1093 19.996 11.1093C17.0192 11.1093 15.019 12.0539 13.687 13.3927C12.6421 14.4415 11.7389 16.0542 11.7389 18.3456C11.7389 20.6356 12.9548 22.8482 14.2802 24.1776C15.504 25.4068 17.428 26.3167 19.3654 26.3167C21.3027 26.3167 23.3028 25.5378 25.3711 23.4601Z",
  fill: "#5952FF"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(OutreachIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;